<div class="profile-menu" (click)="stopPropagation($event)">
  <button class="profile-menu__trigger" (click)="toggle($event)">
    <img class="header__account-photo" [src]="user?.picture" alt="profiel">
  </button>

  @if (isOpen) {
    <div class="profile-menu__dropdown">
      <div class="profile-menu__section">
        @if (currentTenant) {
          <span class="profile-menu__label">{{ currentTenant.name }}</span>
        }
        @if (personHref) {
          <a class="profile-menu__link" (click)="navigateToPerson()">{{ userName }}</a>
        } @else {
          <span>{{ userName }}</span>
        }
        @if (currentTenant && isAdmin) {
          <a class="profile-menu__link" (click)="navigateToSystem()">{{ 'profile.manage_workspace' | translate }}</a>
        }
      </div>
      <div class="profile-menu__section">
        <span class="profile-menu__label">{{ 'profile.switch' | translate }}</span>
        @for (ws of recentWorkspaces; track ws) {
          <a class="profile-menu__link" (click)="navigateTo(ws.tenantCode)">{{ ws.name }}</a>
        }
        <a class="profile-menu__link" [routerLink]="['/']" [queryParams]="{choose: 'true'}" (click)="isOpen = false">{{ 'profile.all_workspaces' | translate }}</a>
      </div>
      <div class="profile-menu__section">
        <a class="profile-menu__link" (click)="logout()">{{ 'profile.logout' | translate }}</a>
      </div>
    </div>
  }
</div>
